// Generated by scripts/update-seeq-icons.js from src/svg/seeq/training.svg.
// Do not edit this file directly; update the source SVG and regenerate.
import type { IconDefinition, IconName } from '@fortawesome/fontawesome-common-types';

export const fcTraining = {
  prefix: 'fak',
  iconName: 'training' as IconName,
  icon: [
    1269,
    1024,
    [],
    'e92e',
    'M35 237.9l552.9-228.6c13.7-5.9 29.6-9.3 46.4-9.3s32.7 3.4 47.2 9.6l-0.8-0.3 553 228.6c46.7 19.3 46.7 102.3 0 121.5l-96.4 40c21.4 35.7 34.4 78.7 35.4 124.5l0 0.3c20 16.9 32.6 42 32.6 70 0 1 0 2.1-0.1 3.1l0-0.1c0 0.6 0 1.3 0 2 0 25.9-10.5 49.4-27.4 66.4v0l50.5 306.3c4.4 26.6-10.7 51.9-30.8 51.9h-111.3c-20.3 0-35.4-25-30.9-51.9l50.6-306.3c-17-17-27.5-40.4-27.5-66.3 0-0.7 0-1.4 0-2.2l0 0.1c0-0.8 0-1.7 0-2.6 0-27.4 12-52 31-68.9l0-0.1c-0.3-38.3-15.9-72.8-41-97.9v0l-387.7 160.3c-13.7 5.9-29.6 9.3-46.4 9.3s-32.7-3.4-47.1-9.6l0.8 0.3-553-228.6c-46.7-19.3-46.7-102.3 0-121.5zM569.4 669.5c19.2 8.3 41.5 13.1 65 13.2s45.8-4.8 66-13.6l-1.1 0.4 287.5-118.7 28.3 302.5c0 94.3-170.4 170.7-380.6 170.7s-380.7-76.4-380.7-170.7l28-302.6z',
  ],
} satisfies IconDefinition;
